import { css } from '@emotion/react';
import { FoundationIcon, Icon, NeutralColorToken, SemanticColorToken, Type } from '@robinhood/design';

import Button from './Button';
import GetHelpTextButton from './GetHelpTextButton';
import GradientBackgroundLayout from './GradientBackgroundLayout';

type BaseProps = {
  title: string;
  subtitle: string;
  icon?: Icon;
  buttonLabel?: string;
  onButtonPress?: () => void;
  buttonState?: 'default' | 'loading';
  showGetHelpButton?: boolean;
};

type PropsIface =
  | (BaseProps & {
      buttonType: 'submit';
      buttonHref?: never;
    })
  | (BaseProps & {
      buttonType: 'anchor';
      buttonHref: string;
    });

const FullPageTerminalStateLayout = ({
  title,
  subtitle,
  icon = 'Checkmark24',
  buttonLabel = 'Done',
  buttonState = 'default',
  buttonType = 'submit',
  buttonHref,
  showGetHelpButton = false,
  onButtonPress,
}: PropsIface) => {
  return (
    <GradientBackgroundLayout>
      <div css={root}>
        <div css={iconContainer}>
          <FoundationIcon type={icon} color={SemanticColorToken.Positive} />
        </div>
        <div css={textContainer}>
          <Type.Display size='L' font='nib'>
            {title}
          </Type.Display>
          <Type.Text size='M' color={NeutralColorToken.Fg2}>
            {subtitle}
          </Type.Text>
        </div>
        <div css={buttonContainer}>
          {buttonType === 'submit' ? (
            <Button label={buttonLabel} state={buttonState} width='full' type='submit' onClick={onButtonPress} />
          ) : (
            <Button
              label={buttonLabel}
              state={buttonState}
              width='full'
              type='anchor'
              href={buttonHref}
              onClick={onButtonPress}
            />
          )}
          {showGetHelpButton && <GetHelpTextButton />}
        </div>
      </div>
    </GradientBackgroundLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

const textContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
`;

const iconContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  & svg {
    width: 52px;
    height: 52px;
  }
`;

export default FullPageTerminalStateLayout;
